import {
  type DynamicClient,
  getOwnerWalletAccountForSmartWalletAccount,
  signMessage as signMessageWithWalletAccount,
} from '@dynamic-labs-sdk/client';
import { assertDefined } from '@dynamic-labs-sdk/client/core';
import type { EvmWalletAccount } from '@dynamic-labs-sdk/evm';

import { createKernelClientForWalletAccount } from '../../createKernelClientForWalletAccount';
import { shouldSignWithEoa } from '../shouldSignWithEoa';

type SignMessageParams = {
  message: string;
  walletAccount: EvmWalletAccount;
};

export const signMessage = async (
  { walletAccount, message }: SignMessageParams,
  client: DynamicClient
): Promise<{ signature: string }> => {
  const kernelClient = await createKernelClientForWalletAccount(
    { smartWalletAccount: walletAccount },
    client
  );

  const shouldUseEoa = await shouldSignWithEoa(
    {
      kernelClient,
      smartWalletAccount: walletAccount,
    },
    client
  );

  if (shouldUseEoa) {
    const eoaWalletAccount = getOwnerWalletAccountForSmartWalletAccount(
      { smartWalletAccount: walletAccount },
      client
    );

    assertDefined(eoaWalletAccount, 'Eoa wallet account not found');

    const { signature } = await signMessageWithWalletAccount({
      message,
      walletAccount: eoaWalletAccount,
    });

    return { signature };
  }

  const signature = await kernelClient.signMessage({ message });
  return { signature };
};
